import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';

/** Per-operation outline-badge colors; operations without an entry use the default. */
const OPERATION_BADGE_COLORS: Record<string, string> = {
  LOGIN:
    'border-purple-200/60 text-purple-600/80 bg-transparent dark:border-purple-800/40 dark:text-purple-400/70',
  LOGOUT:
    'border-amber-200/60 text-amber-600/80 bg-transparent dark:border-amber-800/40 dark:text-amber-400/70',
  DELETED:
    'border-red-200/60 text-red-600/80 bg-transparent dark:border-red-800/40 dark:text-red-400/70',
  CREATED:
    'border-green-200/60 text-green-600/80 bg-transparent dark:border-green-800/40 dark:text-green-400/70',
  REVOKED:
    'border-orange-200/60 text-orange-600/80 bg-transparent dark:border-orange-800/40 dark:text-orange-400/70',
};

const DEFAULT_BADGE_COLOR =
  'border-blue-200/60 text-blue-600/80 bg-transparent dark:border-blue-800/40 dark:text-blue-400/70';

interface OperationBadgeProps {
  operation: string;
}

/** Outline badge showing the raw uppercase operation, colored per operation. */
export function OperationBadge({
  operation,
}: OperationBadgeProps): ReactElement {
  return (
    <Badge
      variant="outline"
      className={OPERATION_BADGE_COLORS[operation] || DEFAULT_BADGE_COLOR}
    >
      {operation}
    </Badge>
  );
}
